module.exports = __webpack_public_path__ + "img/register-award__sku.c0401bb.png";